import React from 'react';

import { Button } from '@/components/ui/button';

export interface SavePipelineChoicePopupProps {
  open: boolean;
  pipelineName: string | null;
  onCancel: () => void;
  onUpdateExisting: () => void;
  onSaveAsNew: () => void;
}

export const SavePipelineChoicePopup: React.FC<SavePipelineChoicePopupProps> = ({
  open,
  pipelineName,
  onCancel,
  onUpdateExisting,
  onSaveAsNew,
}) => {
  if (!open) return null;

  const name = (pipelineName ?? 'this pipeline').trim() || 'this pipeline';

  return (
    <div className="absolute inset-0 pointer-events-none">
      <div className="h-full w-full flex justify-end">
        <div className="pointer-events-auto h-full w-full max-w-md border-l border-border bg-background">
          <div className="h-14 border-b border-border flex items-center justify-between px-6">
            <div className="text-lg font-semibold">Save pipeline</div>
            <Button variant="ghost" size="sm" onClick={onCancel} aria-label="Close">
              ✕
            </Button>
          </div>

          <div className="p-6 overflow-auto h-[calc(100%-3.5rem)]">
            <div className="space-y-4">
              <div>
                <div className="text-sm">
                  You're editing <span className="font-medium">{name}</span>.
                </div>
                <div className="text-sm text-muted-foreground mt-1">
                  Do you want to update the existing pipeline, or save a new copy?
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <Button variant="secondary" size="sm" onClick={onUpdateExisting}>
                  Update existing
                </Button>
                <Button variant="secondary" size="sm" onClick={onSaveAsNew}>
                  Save as new
                </Button>
                <Button variant="ghost" size="sm" onClick={onCancel}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
